import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import styles from "./TechSummit.module.css";
import {
    Box,
    TextField,
    Button,
    Typography,
    CircularProgress,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Card,
    CardContent,
    Divider,
    Grid,
    // --- New MUI Imports for Consistency ---
    FormControl,
    FormLabel,
    RadioGroup,
    FormControlLabel,
    Radio,
    FormGroup,
    Checkbox,
    InputLabel,
    Select,
    MenuItem,
    Alert, // Added Alert for better error/message display
} from "@mui/material";
// You may no longer need styles.css for these elements, but kept it for others
// import styles from "./TechSummitRegistrationPage.module.css"; 
import { loadStripe } from "@stripe/stripe-js";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
// const PRICING_TABLE = {
//     sponsorTiers: {
//         Platinum: 5000,
//         Gold: 3000,
//         Silver: 2000,
//         "Community Partner": 1000,
//     },
//     techAttendee: {
//         actual: 500,
//         discounted: 250,
//     },
// };


const TechsubmitRegistrationPage_new = ({ sponsorshipPackages, sponsorshipBenefits }) => {
    const [participantOptions, setParticipantOptions] = useState([]);
    const [pricing, setPricing] = useState({
    sponsorTiers: [],
    booths: [],
    techAttendee: {},
    });
    // payment
    const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);
    const [selectedTier, setSelectedTier] = useState("");
    const [totalAmount, setTotalAmount] = useState(0);

    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        mobile: "",
        email: "",
        role: "",
        availability: "",
        participantType: [],
        goals: [],
        heardFrom: "",
        suggestions: "",
        udyogconnectuser: "",
        linkedinProfile: "",
        boothSpace:""
    });

    const [errors, setErrors] = useState({});
    const [isUpdating, setIsUpdating] = useState(false);
    const [otpDialogOpen, setOtpDialogOpen] = useState(false);
    const [otpSent, setOtpSent] = useState(false);
    const [otp, setOtp] = useState("");
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");

    useEffect(() => {
        const fetchEventData = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/techsummit2025/getpricedata`);
                
                const eventData = await response.data;
                
                // The BFF ensures this object matches the structure of your old data.js
                setPricing(eventData);
                setParticipantOptions(eventData.participent_options);
            } catch (err) {
                console.error("Failed to fetch data:", err);
                alert(err.message || "An unknown error occurred while fetching data.");
            } finally {
                setLoading(false);
            }
        };

        fetchEventData();
    }, []); 
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        if (type === "checkbox") {
            const arr = formData[name] || [];
            setFormData({
                ...formData,
                [name]: checked ? [...arr, value] : arr.filter((v) => v !== value),
            });
        } else {
            setFormData({ ...formData, [name]: value });
        }

        // Special handling for sponsor tier: clear if "As a sponsor" is unchecked
        if (name === "participantType" && !checked && value === "As a sponsor") {
            setSelectedTier("");
        }
    };

    const handleSelectChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleCheckboxGroupChange = (e, name) => {
        const { value, checked } = e.target;
        const arr = formData[name] || [];
        setFormData({
            ...formData,
            [name]: checked ? [...arr, value] : arr.filter((v) => v !== value),
        });
        // Special handling for sponsor tier on change
        if (name === "participantType" && !checked && value === "As a sponsor") {
             setSelectedTier("");
        }
    };
    

    const openOtpDialog = () => {
        if (!formData.email) {
            setMessage("Please enter email to update registration.");
            return;
        }
        setOtp("");
        setOtpSent(false);
        setOtpDialogOpen(true);
        setMessage("");
    };

    // Send OTP for updating existing user
    const handleSendOtp = async () => {
        if (!formData.email) {
            setMessage("Please enter email to request OTP.");
            return;
        }
        setLoading(true);
        setMessage("");
        try {
            const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/techsummit2025/request-otp`, { email: formData.email });
            setOtpSent(true);
            setMessage(res.data.message || "OTP sent successfully!");
        } catch (err) {
            setMessage(err.response?.data?.message || "Failed to send OTP.");
        } finally {
            setLoading(false);
        }
    };

    // Verify OTP and fetch existing user data
    const handleVerifyOtp = async () => {
        if (!otp) {
            setMessage("Please enter OTP.");
            return;
        }
        setLoading(true);
        setMessage("");
        try {
            const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/techsummit2025/verify-otp`, {
                email: formData.email,
                otp,
            });

            if (res.data.message == 'OTP verified successfully') {
                const userRes = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/techsummit2025/user/${formData.email}`);
                // Convert string fields like participantType/goals to array if needed
                setFormData({
                    ...userRes.data,
                    participantType: userRes.data.participantType
                        ? userRes.data.participantType.split("|")
                        : [],
                    goals: userRes.data.goals ? userRes.data.goals.split("|") : [],
                });
                setMessage("OTP verified. You can now update your details.");
                setOtpDialogOpen(false);
            } else {
                setMessage("Invalid or expired OTP.");
            }
        } catch (err) {
            setMessage("Verification failed.");
        } finally {
            setLoading(false);
        }
    };

    // Validate required fields
    const validate = () => {
        const newErrors = {};
        if (!formData.firstName) newErrors.firstName = "First name required";
        if (!formData.lastName) newErrors.lastName = "Last name required";
        if (!formData.mobile) newErrors.mobile = "Mobile required";
        if (!formData.email) newErrors.email = "Email required";
        if (!formData.role) newErrors.role = "Role required";
        // if (!formData.availability) newErrors.availability = "Availability required";
        if (!formData.participantType.length)
            newErrors.participantType = "Select at least one participant type";
        if (!formData.goals.length) newErrors.goals = "Select at least one goal";
        if (!formData.heardFrom) newErrors.heardFrom = "Please select how you heard";
        if (!formData.udyogconnectuser) newErrors.udyogconnectuser = "Please select";
        if (formData.participantType.includes("As a speaker")) {
        if (!formData.linkedinProfile)
            newErrors.linkedinProfile = "LinkedIn profile URL is required";
        else if (!formData.linkedinProfile.toLowerCase().includes("linkedin.com"))
            newErrors.linkedinProfile = "Please enter a valid LinkedIn profile link";
        }

        return newErrors;
    };

    const handleRegister = async () => {
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        
        if (totalAmount <= 0) {
            alert("Please select at least one paid option before proceeding.");
            return;
        }

        setLoading(true);
        try {
            const stripe = await stripePromise;

            // Create payment session in backend
            const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/techsummit2025/create-checkout-session`, {
                ...formData, // Send all form data
                totalAmount: totalAmount, // Pass the calculated amount
                sponsorTier: selectedTier || null, // Pass the selected tier if applicable
            });
            window.location.href = res.data.url;
        } catch (error) {
            console.error(error);
            alert(error.response.data.message);
        } finally {
            setLoading(false);
        }
    };

    // Update existing user
    const handleUpdate = async () => {
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        setErrors({});
        setLoading(true);
        setMessage("");
        try {
            const res = await axios.put(`${process.env.REACT_APP_API_BASE_URL}/api/techsummit2025/update-user`, formData);
            alert("Registration updated successfully")
            if (formData.udyogconnectuser === "Yes") {
                window.location.href = "/techsummit2025";
            } else {
                window.location.href = "/"; // full redirect to root domain
            }
        } catch (err) {
            setMessage(err.response?.data?.error || "Update failed.");
        } finally {
            setLoading(false);
        }
    };

    // calculate total
    useEffect(() => {
        let total = 0;

        const isSponsor = formData.participantType.includes("As a sponsor");
        const isTechAttendee = formData.participantType.includes("As a tech attendee");
        const isSpeaker = formData.participantType.includes("As a speaker");
        if (isSponsor && selectedTier) {
            total += pricing.sponsorTiers[selectedTier];
        }

        // if (isTechAttendee && !isSponsor && !isSpeaker) {
        //     total += PRICING_TABLE.techAttendee.discounted;
        // }

        if (!isSponsor && (isTechAttendee || isSpeaker)) {
            total += pricing.techAttendee.discounted;
        }
        if (!isSponsor && formData.boothSpace) {
            const selectedBooth = pricing.booths.find(b => b.name === formData.boothSpace);
            if (selectedBooth) {
            total += selectedBooth.price;
            }
        }

        setTotalAmount(total);
    }, [formData.participantType, selectedTier,formData.boothSpace, pricing]);

     const selectedTierDetails = sponsorshipPackages.tiers.find(
            (pkg) => pkg.level === selectedTier
        );
    return (
        <Box sx={{ maxWidth: 600, mx: "auto", mt: 6, p: 4, boxShadow: 3, borderRadius: 3 }}>
            
            {/* Update Button */}
            {/* <Button
                fullWidth
                variant={isUpdating ? "contained" : "outlined"}
                color="secondary"
                sx={{ mb: 3 }}
                onClick={() => {
                    if (!isUpdating && !formData.email) {
                        alert("Please enter email to update registration.");
                        return;
                    }
                    setIsUpdating(!isUpdating);
                    if (!isUpdating) openOtpDialog();
                    else setMessage("");
                }}
            >
                Update My Registration
            </Button> */}

            <Typography variant="h5" sx={{ mb: 2, textAlign: "center" }}>
                {isUpdating ? "Update Registration" : "New Registration"}
            </Typography>

            {/* OTP Dialog */}
            <Dialog open={otpDialogOpen} onClose={() => {
                setOtpDialogOpen(false);
                setIsUpdating(false); 
            }}>
                <DialogTitle>Verify Your Email</DialogTitle>
                <DialogContent>
                    <TextField
                        fullWidth
                        label="Email"
                        value={formData.email}
                        onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                        sx={{ mb: 2 }}
                        disabled={otpSent}
                    />
                    {otpSent && (
                        <TextField
                            fullWidth
                            label="Enter OTP"
                            value={otp}
                            onChange={(e) => setOtp(e.target.value)}
                            sx={{ mb: 2 }}
                        />
                    )}
                    {message && <Alert severity={otpSent ? "info" : "error"} sx={{ mt: 1 }}>{message}</Alert>}
                </DialogContent>
                <DialogActions>
                    {!otpSent ? (
                        <Button onClick={handleSendOtp} disabled={loading}>
                            {loading ? <CircularProgress size={24} /> : "Send OTP"}
                        </Button>
                    ) : (
                        <Button onClick={handleVerifyOtp} disabled={loading}>
                            {loading ? <CircularProgress size={24} /> : "Verify OTP"}
                        </Button>
                    )}
                    <Button onClick={() => { setIsUpdating(false); setOtpDialogOpen(false) }}>Cancel</Button>
                </DialogActions>
            </Dialog>

            {/* Full Form */}
            <Box component="form" sx={{ mt: 2 }}>
                <TextField
                    fullWidth
                    label="First Name"
                    name="firstName"
                    required
                    value={formData.firstName}
                    onChange={handleChange}
                    error={!!errors.firstName}
                    helperText={errors.firstName}
                    sx={{ mb: 2 }}
                />
                <TextField
                    fullWidth
                    required
                    label="Last Name"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    error={!!errors.lastName}
                    helperText={errors.lastName}
                    sx={{ mb: 2 }}
                />
                <TextField
                    fullWidth
                    required
                    label="Mobile Number"
                    name="mobile"
                    value={formData.mobile}
                    onChange={handleChange}
                    error={!!errors.mobile}
                    helperText={errors.mobile}
                    sx={{ mb: 2 }}
                />
                <TextField
                    fullWidth
                    required
                    label="Email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    disabled={isUpdating}
                    error={!!errors.email}
                    helperText={errors.email}
                    sx={{ mb: 2 }}
                />

                {/* Role (Radio Group) */}
                <FormControl component="fieldset" fullWidth sx={{ mb: 3 }} error={!!errors.role}>
                    <FormLabel component="legend" required>Which of the following best describes you?</FormLabel>
                    <RadioGroup
                        name="role"
                        value={formData.role}
                        onChange={handleChange}
                        sx={{ mt: 1 }}
                    >
                        {["Industry leader / Executive", "Tech Practitioner", "Researcher / Academic", "Student / Emerging Professional"].map((opt) => (
                            <FormControlLabel key={opt} value={opt} control={<Radio size="small" />} label={opt} />
                        ))}
                    </RadioGroup>
                    {errors.role && <Typography color="error" variant="caption">{errors.role}</Typography>}
                </FormControl>

                {/* Availability (Radio Group) */}
                {1==2&&(
                    <FormControl component="fieldset" fullWidth sx={{ mb: 3 }}>
                        <FormLabel component="legend" required>Will you be able to attend this event in Dec-2025?</FormLabel>
                        <RadioGroup
                            name="availability"
                            value={formData.availability}
                            onChange={handleChange}
                            sx={{ mt: 1 }}
                        >
                            {["Yes, I'll be there", "Sorry, can't make it", "I will try, but not sure"].map((opt) => (
                                <FormControlLabel key={opt} value={opt} control={<Radio size="small" />} label={opt} />
                            ))}
                        </RadioGroup>
                        {errors.availability && <Typography color="error" variant="caption">{errors.availability}</Typography>}
                    </FormControl>    
                    )
                }
                {/* Participant Type (Checkbox Group) */}
                <FormControl component="fieldset" fullWidth sx={{ mb: 3 }} error={!!errors.participantType}>
                    <FormLabel component="legend" required>Please indicate your participant type</FormLabel>
                    <FormGroup sx={{ mt: 1 }}>
                        {participantOptions.map((opt) => (
                            <FormControlLabel
                                key={opt}
                                control={
                                    <Checkbox
                                        checked={formData.participantType.includes(opt)}
                                        onChange={(e) => handleCheckboxGroupChange(e, 'participantType')}
                                        value={opt}
                                        size="small"
                                    />
                                }
                                label={opt}
                            />
                        ))}
                    </FormGroup>
                    {errors.participantType && <Typography color="error" variant="caption">{errors.participantType}</Typography>}
                </FormControl>

                {/* Goals (Checkbox Group) */}
                <FormControl component="fieldset" fullWidth sx={{ mb: 3 }} error={!!errors.goals}>
                    <FormLabel component="legend" required>What are you hoping to get out of this event?</FormLabel>
                    <FormGroup sx={{ mt: 1 }}>
                        {[
                            "Technology awareness",
                            "Networking",
                            "Want to brand my company or product",
                            "Job opportunities",
                            "Career growth",
                        ].map((opt) => (
                            <FormControlLabel
                                key={opt}
                                control={
                                    <Checkbox
                                        checked={formData.goals.includes(opt)}
                                        onChange={(e) => handleCheckboxGroupChange(e, 'goals')}
                                        value={opt}
                                        size="small"
                                    />
                                }
                                label={opt}
                            />
                        ))}
                    </FormGroup>
                    {errors.goals && <Typography color="error" variant="caption">{errors.goals}</Typography>}
                </FormControl>

                {/* Heard From (MUI Select) */}
                <FormControl fullWidth sx={{ mb: 3 }} error={!!errors.heardFrom}>
                    <InputLabel id="heard-from-label" required>How did you hear about this event?</InputLabel>
                    <Select
                        labelId="heard-from-label"
                        name="heardFrom"
                        value={formData.heardFrom}
                        label="How did you hear about this event?"
                        onChange={handleSelectChange}
                    >
                        <MenuItem value="">Select an option</MenuItem>
                        {["Website", "Friend", "Newsletter", "Advertisement"].map((opt) => (
                            <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                        ))}
                    </Select>
                    {errors.heardFrom && <Typography color="error" variant="caption">{errors.heardFrom}</Typography>}
                </FormControl>

                {/* Suggestions (Textarea replacement with TextField multiline) */}
                <TextField
                    fullWidth
                    multiline
                    rows={4}
                    label="Your suggestions matter! (optional)"
                    name="suggestions"
                    value={formData.suggestions}
                    onChange={handleChange}
                    sx={{ mb: 3 }}
                />

                {/* Udyog Connect User (Radio Group) */}
                <FormControl component="fieldset" fullWidth sx={{ mb: 3 }} error={!!errors.udyogconnectuser}>
                    <FormLabel component="legend" required>Are you a Udyog connect registered user?</FormLabel>
                    <RadioGroup
                        name="udyogconnectuser"
                        value={formData.udyogconnectuser}
                        onChange={handleChange}
                        sx={{ mt: 1 }}
                    >
                        {["Yes", "No"].map((opt) => (
                            <FormControlLabel key={opt} value={opt} control={<Radio size="small" />} label={opt} />
                        ))}
                    </RadioGroup>
                    {errors.udyogconnectuser && <Typography color="error" variant="caption">{errors.udyogconnectuser}</Typography>}
                </FormControl>
                {/* LinkedIn Profile (only if As a speaker selected) */}
                {formData.participantType.includes("As a speaker") && (
                    <TextField
                        fullWidth
                        required
                        multiline
                        rows={3}
                        label="LinkedIn Profile URL and Short Summary"
                        name="linkedinProfile"
                        value={formData.linkedinProfile}
                        onChange={handleChange}
                        error={!!errors.linkedinProfile}
                        helperText={errors.linkedinProfile || "Include your LinkedIn URL and a short intro"}
                        sx={{ mb: 3 }}
                        placeholder="Paste your LinkedIn profile URL and write a short summary..."
                    />
                )}
                {/* Sponsor Tier Section (MUI Select) */}
                {formData.participantType.includes("As a sponsor") && (
                    <FormControl fullWidth sx={{ mb: 3 }}>
                        <InputLabel id="sponsor-tier-label">Select Sponsorship Tier</InputLabel>
                        <Select
                            labelId="sponsor-tier-label"
                            value={selectedTier}
                            label="Select Sponsorship Tier"
                            onChange={(e) => setSelectedTier(e.target.value)}
                        >
                            <MenuItem value="">Select Tier</MenuItem>
                            {Object.entries(pricing.sponsorTiers).map(([tier, value]) => (
                                <MenuItem key={tier} value={tier}>
                                    {tier} - ${value}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                )}
                {/* Booth Space - show only if NOT a sponsor */}
                {!formData.participantType.includes("As a sponsor") && (
                <FormControl fullWidth sx={{ mb: 3 }}>
                    <TextField
                    select
                    label="Select Booth Space"
                    fullWidth
                    value={formData.boothSpace || ""}
                    onChange={(e) => setFormData({ ...formData, boothSpace: e.target.value })}
                    sx={{ mt: 2 }}
                    >
                    <MenuItem value="">No Booth Space</MenuItem>
                    {pricing.booths.map((b) => (
                        <MenuItem key={b.booth_id} value={b.name}>
                        {b.name} - ${b.price} ({b.details})
                        </MenuItem>
                    ))}
                    </TextField>
                </FormControl>
                )}
                {/* Total Section — Modernized & Consistent with TechSummit Style */}
              <Card
  elevation={8}
  sx={{
    mb: 4,
    borderRadius: { xs: 2, sm: 4 },
    background: "linear-gradient(145deg, #0f172a 0%, #1e293b 100%)",
    border: "1px solid rgba(56, 189, 248, 0.3)",
    color: "#f1f5f9",
    overflow: "hidden",
    width: "100%",
  }}
>
  <CardContent
    sx={{
      px: { xs: 2, sm: 4 },
      py: { xs: 2, sm: 3 },
    }}
  >
    {/* --- Header --- */}
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        alignItems: { xs: "flex-start", sm: "center" },
        mb: 2,
        gap: 1,
      }}
    >
      <LocalOfferIcon sx={{ color: "#38bdf8", fontSize: 28 }} />
      <Typography
        variant="h6"
        fontWeight="bold"
        sx={{
          color: "#38bdf8",
          textAlign: { xs: "left", sm: "center" },
        }}
      >
        Order Summary
      </Typography>
    </Box>

    <Divider sx={{ borderColor: "rgba(255,255,255,0.1)", mb: 3 }} />

    {/* --- Fee Section --- */}
    <Grid container spacing={1}>
      {(formData.participantType.includes("As a tech attendee") ||
        formData.participantType.includes("As a speaker")) && (
        <Grid
          item
          xs={12}
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            alignItems: { xs: "flex-start", sm: "center" },
            rowGap: 1,
          }}
        >
          <Typography variant="body1">
            <CheckCircleOutlineIcon
              fontSize="small"
              sx={{ color: "#38bdf8", verticalAlign: "middle", mr: 0.5 }}
            />
            Tech Attendee Fee
          </Typography>
          <Typography variant="body1" sx={{ fontWeight: 500 }}>
            <span
              style={{
                textDecoration: "line-through",
                color: "#64748b",
                marginRight: 8,
              }}
            >
              ${pricing.techAttendee.actual}
            </span>
            <span style={{ color: "#22c55e", fontWeight: 600 }}>
              ${pricing.techAttendee.discounted}
            </span>
          </Typography>
        </Grid>
      )}

      {formData.participantType.includes("As a sponsor") && selectedTier && (
        <Grid
          item
          xs={12}
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            alignItems: { xs: "flex-start", sm: "center" },
            rowGap: 1,
          }}
        >
          <Typography variant="body1" sx={{ color: "#fbbf24" }}>
            ✨ Sponsor Tier ({selectedTier})
          </Typography>
          <Typography variant="body1" sx={{ fontWeight: 600 }}>
            ${pricing.sponsorTiers[selectedTier]}
          </Typography>
        </Grid>
      )}

      {!formData.participantType.includes("As a sponsor") &&
        formData.boothSpace && (
          <Grid
            item
            xs={12}
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              justifyContent: "space-between",
              alignItems: { xs: "flex-start", sm: "center" },
              rowGap: 1,
            }}
          >
            <Typography variant="body1">
              🏢 Booth Space ({formData.boothSpace})
            </Typography>
            <Typography variant="body1" sx={{ fontWeight: 600 }}>
              $
              {pricing.booths.find(
                (b) => b.name === formData.boothSpace
              )?.price || 0}
            </Typography>
          </Grid>
        )}
    </Grid>

    {/* --- Sponsor Benefits --- */}
    {selectedTierDetails && (
      <Box
        sx={{
          mt: 4,
          p: { xs: 2, sm: 3 },
          borderRadius: 3,
          background: "linear-gradient(135deg, #1e293b 0%, #0f172a 100%)",
          border: "1px solid rgba(56,189,248,0.2)",
          boxShadow: "0 0 15px rgba(56,189,248,0.15)",
        }}
      >
        <Typography
          variant="h6"
          sx={{ color: "#38bdf8", fontWeight: 700, mb: 1 }}
        >
          {selectedTierDetails.level} Sponsor — {selectedTierDetails.price}
        </Typography>

        <Typography variant="body2" sx={{ color: "#94a3b8", mb: 2 }}>
          {selectedTierDetails.description}
        </Typography>

        <Typography
          variant="subtitle1"
          sx={{ color: "#a78bfa", fontWeight: 600, mb: 1 }}
        >
          Benefits Included:
        </Typography>
        <ul style={{ lineHeight: "1.8em", marginLeft: "18px" }}>
          {selectedTierDetails.features.map((f, i) => (
            <li key={i}>{f}</li>
          ))}
        </ul>
      </Box>
    )}

    <Divider sx={{ mt: 3, mb: 3, borderColor: "rgba(255,255,255,0.1)" }} />

    {/* --- Total Payable Section --- */}
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        justifyContent: "space-between",
        alignItems: { xs: "flex-start", sm: "center" },
        gap: 1,
        p: 2,
        borderRadius: 2,
        background: "rgba(56,189,248,0.1)",
        backdropFilter: "blur(6px)",
      }}
    >
      <Typography variant="h6" fontWeight="bold" sx={{ color: "#e2e8f0" }}>
        Total Payable
      </Typography>
      <Typography
        variant="h4"
        fontWeight="bold"
        sx={{
          color: "#22c55e",
          letterSpacing: 1,
          fontSize: { xs: "1.8rem", sm: "2.125rem" },
        }}
      >
        ${totalAmount}
      </Typography>
    </Box>
  </CardContent>
</Card>

                <Button
                    fullWidth
                    variant="contained"
                    onClick={isUpdating ? handleUpdate : handleRegister}
                    disabled={loading}
                    sx={{ height: 56 }}
                >
                    {loading ? <CircularProgress size={24} color="inherit" /> : (isUpdating ? "Update Registration" : `Proceed to Pay $${totalAmount}`)}
                </Button>
            </Box>

            {message && <Typography sx={{ mt: 2, textAlign: "center" }}>{message}</Typography>}
        </Box>
    );
}
export default TechsubmitRegistrationPage_new;